import { Row, Col } from 'antd';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo, faRedo } from '@fortawesome/free-solid-svg-icons'


const TopBar = ({ setSvg, svgHistory, historyIndex, setHistoryIndex, undoActions, setUndoActions, redoActions, setRedoActions, updateSVGJoined }) => {

    function mod(n, m) {
        return ((n % m) + m) % m;
    }

    const undo = () => {
        console.log("undo, redo, history index: ", undoActions, redoActions, historyIndex);
        if (undoActions > 1) {
            // console.log("svgHistory: ", svgHistory);
            console.log("history index: ", (historyIndex - 2) % 50)
            let item = JSON.parse(JSON.stringify(svgHistory[mod(historyIndex - 2, 50)]));;
            setSvg(item);
            updateSVGJoined(item);

            setHistoryIndex(mod((historyIndex - 1), 50));
            setUndoActions(undoActions - 1);
            setRedoActions(redoActions + 1);
        }
    }

    const redo = () => {
        console.log("undo, redo, history index: ", undoActions, redoActions, historyIndex);
        if (redoActions > 0) {
            // console.log("svgHistory: ", svgHistory);
            let item = JSON.parse(JSON.stringify(svgHistory[(historyIndex) % 50]));;
            setSvg(item);
            updateSVGJoined(item);
            setHistoryIndex((historyIndex + 1) % 50);
            setRedoActions(redoActions - 1);
            setUndoActions(undoActions + 1);
        }
    }

    return (
        <>
            <Col style={{ marginTop:"5px",marginLeft: 10 }} >
                <Button type="text" disabled={(undoActions <= 1)} onClick={() => undo()} value="undo">
                    <Row justify="center" >
                        <FontAwesomeIcon icon={faUndo} size={14} />
                    </Row>
                </Button>
                <Button type="text" disabled={(redoActions <= 0)} onClick={() => redo()} value="redo">
                    <Row justify="center" >
                        <FontAwesomeIcon icon={faRedo} size={14} />
                    </Row>
                </Button>
            </Col>
        </>
    );

}


export default TopBar;


